module.exports = __webpack_public_path__ + "img/instagram-logo.3ea1511d.svg";